export default __webpack_public_path__ + "static/media/heroimg.c5a37168.svg";